export default __webpack_public_path__ + "static/media/logo-4.64318d17.jpg";